export interface SegmentRange {
  lo: number;
  hi: number;
}

/**
 * Continuous 1-based [lo, hi] question-number ranges for each think segment,
 * derived from the run/think config. Mirrors the SQL `_quizrun_segment_range`
 * used by form_open/form_submit: numbering is continuous across segments, and
 * the last think segment absorbs any overflow beyond the configured think
 * capacity. Returns one range per think length (empty array when there are no
 * think segments — callers treat the whole bank as a single segment).
 */
export function thinkSegmentRanges(
  thinkLengths: number[],
  maxNumber: number,
): SegmentRange[] {
  const n = thinkLengths.length;
  const ranges: SegmentRange[] = [];
  let lo = 1;
  for (let i = 0; i < n; i++) {
    const hi =
      i === n - 1
        ? Math.max(lo + thinkLengths[i] - 1, maxNumber)
        : lo + thinkLengths[i] - 1;
    ranges.push({ lo, hi });
    lo += thinkLengths[i];
  }
  return ranges;
}
